// TODO: refactor with data from categories in productList and Menu
// TODO: refactor with cache from productList
const initialState = {
  current: {
    id: null,
    name: null,
    parentCategories: null,
    url: null,
  },
};

export const types = {
  setCategory: 'categories/setCategory',
};

// getters
export const getters = {
  current: 'categories/current',
  currentParentCategories: 'categories/currentParentCategories',
};

// actions
const actions = {
  setCategory({ commit }, category) {
    commit('setCurrent', category);
  },
};

// mutations
const mutations = {
  setCurrent(state, category) {
    state.current.id = category.id;
    state.current.name = category.name;
    state.current.parentCategories = category.parentCategories;
    state.current.url = category.url;
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    current: (state) => state.current,
    currentParentCategories: (state) => state.current.parentCategories,
  },
  actions,
  mutations,
};
